// The company's email templates as entries of the "Actions" menu (employee
// list and profile): one entry per template, under "Notices".
const PREFIX = 'notice:';

export const noticeActionOptions = (templates, groupValue) =>
  (templates || []).map((tpl) => ({
    key: `${PREFIX}${tpl._id}`,
    value: `${PREFIX}${tpl._id}`,
    label: tpl.name,
    groupValue,
    dotColor: 'bg-secondary',
  }));

/** The template id of a notice action, or null for any other action. */
export const noticeTemplateIdOf = (action) =>
  typeof action === 'string' && action.startsWith(PREFIX)
    ? action.slice(PREFIX.length)
    : null;
